import '../main.scss';

import BaseComponent from './base.js';
import Dashboard from './dashboard/dashboard.js';
import keyboard from './keyboard/keyboard.js';

export default class Page extends BaseComponent {
  constructor() {
    super({ elementTag: 'main' });
    this.appendChildren(new Dashboard(), keyboard);
  }

  /**
   * Appends the page component to document's body.
   * @returns {void}
   */
  mount() {
    document.body.append(this.getElement());
  }
}
